export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://os.alipayobjects.com/rmsportal/mlcYmsRilwraoAe.svg',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '/home',
          children: [{ children: 'nav.index', name: 'text' }],
        },
        // subItem: [
        //   {
        //     name: 'sub0',
        //     className: 'item-sub',
        //     children: {
        //       className: 'item-sub-item',
        //       children: [
        //         {
        //           name: 'content',
        //           className: 'item-content',
        //           children: '企业级 UI 设计体系',
        //         },
        //       ],
        //     },
        //   },
        //   {
        //     name: 'sub1',
        //     className: 'item-sub',
        //     children: {
        //       className: 'item-sub-item',
        //       children: [
        //         {
        //           name: 'content',
        //           className: 'item-content',
        //           children: '企业级 UI 设计体系',
        //         },
        //       ],
        //     },
        //   },
        // ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/about',
          children: [{ children: 'nav.about', name: 'text' }],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/news',
          children: [{ children: 'nav.news', name: 'text' }],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/product',
          children: [{ children: 'nav.products', name: 'text' }],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              href: '/product/ota',
              children: [
                {
                  name: 'OTA',
                  className: 'item-content',
                  children: 'home.ota',
                },
              ],
            },
          }, {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              href: '/product/diagnosis',
              children: [
                {
                  name: 'Diagnosis',
                  className: 'item-content',
                  children: 'home.diagnosis',
                },
              ],
            },
          }, {
            name: 'sub2',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              href: '/product/basic',
              children: [
                {
                  name: 'Vehicle',
                  className: 'item-content',
                  children: 'home.vehicle',
                },
              ],
            },
          }, {
            name: 'sub3',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              href: '/product/eLearn',
              children: [
                {
                  name: 'ELearn',
                  className: 'item-content',
                  children: 'home.eLearn',
                },
              ],
            },
          }, {
            name: 'sub4',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              href: '/product/test',
              children: [
                {
                  name: 'Test',
                  className: 'item-content',
                  children: 'home.test',
                },
              ],
            },
          }, {
            name: 'sub5',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              href: '/product/tool',
              children: [
                {
                  name: 'Toll',
                  className: 'item-content',
                  children: 'home.tool',
                },
              ],
            },
          }
        ],
      },
      // {
      //   name: 'item4',
      //   className: 'header0-item',
      //   children: {
      //     href: '/download',
      //     children: [{ children: 'nav.download', name: 'text' }],
      //   },
      // },
      // {
      //   name: 'item5',
      //   className: 'header0-item',
      //   children: {
      //     href: '/login',
      //     children: [{ children: 'nav.login', name: 'text' }],
      //   },
      // },
      {
        name: 'item6',
        // className: 'header0-item',
        children: {
          href: '/contact',
          children: [{ children: 'nav.contact', name: 'text' }],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};

export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 5,
        className: 'block',
        title: {
          className: 'logo',
          children: 'https://zos.alipayobjects.com/rmsportal/qqaimmXZVSwAhpL.svg',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: 'home.aboutTitle',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 12,
        md: 5,
        className: 'block',
        title: { children: 'footer.product' },
        childWrapper: {
          children: [
            { name: 'link0', href: '/product/ota', children: 'home.ota' },
            { name: 'link1', href: '/product/diagnosis', children: 'home.diagnosis' },
            { name: 'link3', href: '/product/basic', children: 'home.vehicle' },
            { name: 'link2', href: '/product/eLearn', children: 'home.eLearn' },
            { name: 'link2', href: '/product/test', children: 'home.test' },
            { name: 'link2', href: '/product/tool', children: 'home.tool' },
          ],
        },
      },
      {
        name: 'block2',
        xs: 12,
        md: 8,
        className: 'block',
        title: { children: 'footer.connectUs' },
        childWrapper: {
          children: [
            {
              name: 'link0',
              children: 'footer.email',
              img: {
                className: 'contact-icon',
                children: require('@/assets/footer/email.png')
              },
            },
            // {
            //   name: 'link1',
            //   children: 'footer.phone',
            //   img: {
            //     className: 'contact-icon',
            //     children: require('@/assets/footer/phone.png'),
            //   },
            // },
            {
              name: 'link1',
              children: 'footer.address',
              img: {
                className: 'contact-icon',
                children: require('@/assets/footer/address.png'),
              },
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 12,
        md: 3,
        className: 'block',
        title: { children: 'footer.link' },
        childWrapper: {
          children: [
            { href: 'https://www.fawsn.com.cn/', target: '_blank', name: 'link0', children: 'footer.fawSn' },
            { href: 'https://excelfore.com/', target: '_blank', name: 'link1', children: 'footer.excelforeUs' },
          ],
        },
      },
      {
        name: 'block4',
        xs: 12,
        md: 3,
        className: 'block block4',
        title: { children: 'footer.followUs' },
        childWrapper: {
          children: [{
            name: 'link0',
            img: {
              className: 'contact-icon',
              children: require('@/assets/footer/official-accounts.png')
            },
          }]
        },
      },
      // {
      //   name: 'block3',
      //   xs: 24,
      //   md: 6,
      //   className: 'block',
      //   title: { children: '平台演示' },
      //   childWrapper: {
      //     children: [
      //       { href: '/login#eSyncOTA', name: 'link0', children: 'eSync OTA平台' },
      //       { href: '/login#cloudDiagnostics', name: 'link1', children: '远程诊断平台' },
      //     ],
      //   },
      // },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: 'footer.copyright',
  },
};
